module.exports = "./img/1cc5bb089c40661c7afd72bd37283307.png";